export const ACTIVATE_PLAN = "ACTIVATE_PLAN";
export const CHANGE_PRICING = "CHANGE_PRICING";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
